import { useTranslation } from 'react-i18next';
import { Popover } from 'antd';
import {
  EMPTY_ILLUSTRATIONS,
  EmptyContainer,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { getAssignTo, getTaskStatusClass } from './tasks-list-table.helpers';

import TasksListRowActions from './tasks-list-row-actions.component';

import { ITaskListTableProps } from './tasks-list-table.interfaces';

import {
  PopoverContentWrapper,
  AssignToDetailsWrapper,
  AssignToRow,
  StyledTasksTable,
} from './tasks-list-table.styles';

const TasksListTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  loading,
}: ITaskListTableProps) => {
  const { t } = useTranslation(['common', 'processBuilder']);

  return (
    <StyledTasksTable
      loading={loading}
      dataSource={dataSource}
      pagination={paginationConfig}
      rowKey={record => record._id}
      onRow={record => {
        const rowClass = getTaskStatusClass(record);
        return {
          className: rowClass,
        };
      }}
      locale={{
        emptyText: (
          <EmptyContainer
            illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
            emptyTitle={t('processBuilder:tasks.labels.noTasksYet')}
          />
        ),
      }}
      t={t}
    >
      <StyledTasksTable.Column
        title={t('processBuilder:tasks.labels.title')}
        render={({ title }) => <Typography>{title}</Typography>}
      />
      <StyledTasksTable.Column
        title={t('processBuilder:tasks.labels.source')}
        render={({ type }) => (
          <Typography>{t(`processBuilder:tasks.types.${type.toLowerCase()}`)}</Typography>
        )}
      />

      <StyledTasksTable.Column
        title={t('processBuilder:tasks.labels.assignedTo')}
        render={task => {
          const item = getAssignTo(task) || '-';
          return (
            <AssignToDetailsWrapper>
              <Popover
                arrowPointAtCenter
                placement="topRight"
                trigger="hover"
                title={''}
                content={
                  <PopoverContentWrapper>
                    <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{item}</Typography>
                  </PopoverContentWrapper>
                }
              >
                <AssignToRow>{item}</AssignToRow>
              </Popover>
            </AssignToDetailsWrapper>
          );
        }}
      />
      <StyledTasksTable.Column
        title={t('employee:labels.createdBy')}
        render={({ assignedByMember }) => (
          <Typography>{assignedByMember?.profile?.displayName}</Typography>
        )}
      />
      <StyledTasksTable.Column
        width={50}
        title={t('common:labels.action')}
        render={record => <TasksListRowActions record={record} handleModals={handleModals} t={t} />}
      />
    </StyledTasksTable>
  );
};

export default TasksListTable;
